export default "__VITE_ASSET__1bbd7bf5__"